import {Kind} from "graphql";

export default ({typeDefs}) => {
    const inputs = {}
    typeDefs = {
        ...typeDefs,
        definitions: typeDefs.definitions.map(def => {
            if (def.kind === Kind.INPUT_OBJECT_TYPE_DEFINITION) {
                def.directives = def.directives.filter(directive => {
                    if (directive.name.value === 'handleInput') {
                        const handler = directive.arguments.find(({name: {value}}) => value === 'handler').value.value;
                        if (handler) {
                            inputs[def.name.value] = handler;
                        }
                        return false;
                    }
                    return true;
                })
            }
            return def;
        })
    }
    return {typeDefs, inputs};
}
